import sharedAvailabilityModule from './shared/availability';
import sharedBaseModule from './shared/base';
import sharedGuestModule from './shared/guest';
import sharedItemModule from './shared/item';
import sharedCheckoutModule from './shared/checkout';
import sharedPaymentCore from './shared/journey-ui/core';
import sharedPaymentModule from './shared/journey-ui/payment';
import baseModule from './base';
import dashboardModule from './dashboard';
import authModule from './auth';
import userModule from './user';
import propertyModule from './property';
import treatmentModule from './treatment';
import daysModule from './days';
import eventModule from './event';
import integrationModule from './integration';
import periodModule from './period';
import pageContentModule from './pageContent';
import upgradeModule from './upgrade';
import availabilityModule from './availability';
import offerModule from './offer';
import orderModule from './order';
import reportModule from './reports';
import discountModule from './discounts';
import basketModule from './basket';
import orderCreationModule from './orderCreation';
import guestsModule from './guests';
import checkoutModule from './checkout';
import activityModule from './activity';
import journeyUiAuthModule from './journey-ui/auth';

export const modules = [
  sharedAvailabilityModule,
  sharedBaseModule,
  sharedGuestModule,
  sharedItemModule,
  sharedCheckoutModule,
  sharedPaymentCore,
  sharedPaymentModule,
  baseModule,
  dashboardModule,
  authModule,
  userModule,
  propertyModule,
  treatmentModule,
  daysModule,
  eventModule,
  periodModule,
  pageContentModule,
  upgradeModule,
  availabilityModule,
  offerModule,
  orderModule,
  reportModule,
  discountModule,
  integrationModule,
  basketModule,
  orderCreationModule,
  checkoutModule,
  guestsModule,
  activityModule,
  journeyUiAuthModule
];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/index.js